// Solmi Discord invite links, one per placement group. Discord's Server
// Settings → Invites counts joins per link, so a separate link per surface
// shows which one actually brings people in; the `discord_click` analytics
// event (`placement` property) gives the click-level detail on web and mobile.
// Every key starts on the original server-wide invite until its own link is
// created in Discord — swap the URL here, nothing else changes.
export const DISCORD_DEFAULT_INVITE_URL = "https://discord.com/invite/Vn6RKD8WrR";

export const DISCORD_INVITES = {
  /** Web headers, menus, sidebar and footers. */
  site: DISCORD_DEFAULT_INVITE_URL,
  /** "Share on Discord" next to a finished video in Studio (→ #showcase). */
  postRender: DISCORD_DEFAULT_INVITE_URL,
  /** Welcome email. */
  emailWelcome: DISCORD_DEFAULT_INVITE_URL,
  /** "Your music video is ready" email (→ #showcase). */
  emailVideoReady: DISCORD_DEFAULT_INVITE_URL,
  /** Mobile app: Library/Profile header icons and the Feedback screen. */
  app: DISCORD_DEFAULT_INVITE_URL,
  /** Mobile app: "Share on Discord" under a finished video (→ #showcase). */
  appPostRender: DISCORD_DEFAULT_INVITE_URL,
  /** Support email replies (added by hand, see the triage-support skill). */
  support: DISCORD_DEFAULT_INVITE_URL,
} as const;

export type DiscordInviteKey = keyof typeof DISCORD_INVITES;

/** Web surfaces that link to Discord; sent as `placement` on `discord_click`. */
export type DiscordClickPlacement =
  | "landing_header"
  | "landing_menu"
  | "landing_footer"
  | "app_header"
  | "app_sidebar"
  | "studio_header"
  | "stepper_post_render"
  | "video_tab_post_render";

/** Mobile app surfaces that link to Discord (`discord_click` `placement`). */
export type DiscordAppClickPlacement =
  | "mobile_library_header"
  | "mobile_profile_header"
  | "mobile_feedback"
  | "mobile_post_render";
